import React, { useState } from 'react';
import Code from './Code'

import './App.css';
import Buttons from './components/Buttons';
import Header from "./components/Farbe";
import Logo from './components/Logo'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Welcome from './components/Home';


function App() {

  const [validation, setValidation] = useState(false);

  if (!validation) {

    return (
      <Code setValidation={setValidation} />
    );
  }

  else {


    return (


      <div className='container'>
  
<Buttons />



      </div>

    );
  }
}

export default App;
